import type { ReactElement } from 'react';

interface CaretIconProps {
  size?: number;
}

export const CaretIcon = ({ size = 24 }: CaretIconProps): ReactElement => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 8.25L12 15.75L4.5 8.25"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
